module.exports = __webpack_public_path__ + "img/1.be05cb09.jpg";